/**
 * Configuracion de la SPA.
 *
 * Prioridad:
 *   1. `window.__ENV__` -> lo inyecta el contenedor en tiempo de arranque.
 *   2. Variables `VITE_*` -> desarrollo local.
 *   3. Valores por defecto para `npm run dev` sin .env.
 *
 * Aqui no hay ningun secreto: el client de Keycloak es publico (PKCE), y esa
 * es exactamente la razon por la que puede viajar al navegador.
 */

export interface RuntimeConfig {
  apiUrl: string;
  keycloakUrl: string;
  keycloakRealm: string;
  keycloakClientId: string;
  appName: string;
  appTagline: string;
}

interface WindowEnv {
  API_URL?: string;
  KEYCLOAK_URL?: string;
  KEYCLOAK_REALM?: string;
  KEYCLOAK_CLIENT_ID?: string;
}

declare global {
  interface Window {
    __ENV__?: WindowEnv;
  }
}

function pick(runtime: string | undefined, build: string | undefined, fallback: string): string {
  const value = runtime?.trim() || build?.trim() || fallback;
  return value.replace(/\/$/, '');
}

const runtime = typeof window !== 'undefined' ? (window.__ENV__ ?? {}) : {};

export const config: RuntimeConfig = {
  apiUrl: pick(runtime.API_URL, import.meta.env.VITE_API_URL, 'http://localhost:4000'),
  keycloakUrl: pick(
    runtime.KEYCLOAK_URL,
    import.meta.env.VITE_KEYCLOAK_URL,
    'http://localhost:8080',
  ),
  keycloakRealm: pick(
    runtime.KEYCLOAK_REALM,
    import.meta.env.VITE_KEYCLOAK_REALM,
    'electrodavisan',
  ),
  keycloakClientId: pick(
    runtime.KEYCLOAK_CLIENT_ID,
    import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
    'electrodavisan-ecosystem-web',
  ),
  appName: 'ED Ecosystem',
  appTagline: 'Ecosistema unificado de aplicaciones y soporte',
};

export const ROUTES = {
  home: '/',
  login: '/login',
  callback: '/auth/callback',
  apps: '/apps',
  announcements: '/anuncios',
  newTicket: '/support/new',
  tickets: '/tickets',
  ticketDetail: (id: string) => `/tickets/${id}`,
  profile: '/profile',
  supportTickets: '/support/tickets',
  supportTicketDetail: (id: string) => `/support/tickets/${id}`,
  adminApps: '/admin/apps',
  adminAccess: '/admin/access',
  adminUsers: '/admin/users',
  adminAudit: '/admin/audit',
  forbidden: '/403',
  docs: '/docs',
} as const;
